import { defaultMeta } from '@/constants/defaultMeta';
import { useCan } from '@/components/can/Can';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { referralReportQueries } from '@/services/dashboard/referralReports/referralReports.queries';
import { useParams, useSearch } from '@tanstack/react-router';
import type { DateRange } from 'react-day-picker';

export const useCustomerReferralDetails = (dateRange?: DateRange) => {
  const canReadDetails = useCan({ allOf: [PERMS.affiliate.referral.customer.report.view] });
  const { reportType, referrerId } = useParams({
    from: '/(app)/dashboard/referral-reports/$reportType/$referrerId/',
  });
  const { sort, q } = useSearch({ from: '/(app)/dashboard/referral-reports/$reportType/$referrerId/' });
  const { data, isLoading } = useQuery({
    ...referralReportQueries.customerDetails({
      affiliateId: referrerId,
      search: q,
      fromDate: dateRange?.from ? new Date(dateRange.from).setHours(0, 0, 0, 0) : 0,
      toDate: dateRange?.to ? new Date(dateRange.to).setHours(23, 59, 59, 999) : 0,
    }),
    enabled: reportType === 'affiliate' && canReadDetails,
    select: (response) => ({ ...response, data: sortBy(response.data ?? [], sort) }),
  });

  return {
    customerReferralDetails: data?.data ?? [],
    isLoading,
    pagination: data?.meta?.pagination ?? defaultMeta,
  };
};
